import React from 'react';
import { Tile, TileProps } from './Tile';
import { TextType, ViewIntent } from '../common/props';
import { Text } from '../typography/Text';
import classNames from 'classnames';
import * as Classes from '../common/classes';

type ValueTileProps = TileProps & {
  intent: ViewIntent;
  children?: React.ReactNode;
  textType?: TextType;
};

/*
 * Wrapper pro Tile, který slouží pro zobrazení hodnoty, která je velikostně jako <Text type="tileValue"/>.
 * Výchozí velikost tile je: 2x1.
 */
export const ValueTile: React.FC<ValueTileProps> = ({
  children,
  intent,
  backgroundIntent,
  width = 2,
  height = 1,
  textType = 'tileValue',
  ...others
}) => {
  const titleCls = classNames({
    //barevne variace
    [Classes.TILE_TITLE_DANGER]: backgroundIntent === 'danger',
    [Classes.TILE_TITLE_SUCCESS]: backgroundIntent === 'success',
    [Classes.TILE_TITLE_WARNING]: backgroundIntent === 'warning',
    [Classes.TILE_TITLE_INACTIVE]: backgroundIntent === 'inactive',
  });

  return (
    <Tile
      width={width}
      height={height}
      backgroundIntent={backgroundIntent}
      {...others}
    >
      <Text
        className={titleCls}
        intent={intent ?? 'inherit'}
        type={textType}
      >
        {children}
      </Text>
    </Tile>
  );
};
